import { useWatch } from 'react-hook-form';
import {
  ALERTS_QH_CONFLICT_MESSAGE,
  ALERTS_STO_CONFLICT_MESSAGE,
  ALERTS_STO_QH_CONFLICT_MESSAGE,
} from 'modules/campaigns/lib/constants';

export const useAlertsConflict = (): string => {
  const [useQuietHours, useSendTimeOptimization, campaignAlertsEnabled] = useWatch({
    name: ['useQuietHours', 'useSendTimeOptimization', 'campaignAlertsEnabled'],
  });

  let message = '';

  if (campaignAlertsEnabled) {
    if (useSendTimeOptimization && useQuietHours) message = ALERTS_STO_QH_CONFLICT_MESSAGE;
    else if (useSendTimeOptimization) message = ALERTS_STO_CONFLICT_MESSAGE;
    else if (useQuietHours) message = ALERTS_QH_CONFLICT_MESSAGE;
  }

  return message;
};
